import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import ApiService from "../../services/ApiService";

import { getProfilePicture } from "../../utilities/Helpers";
import checkmark from '../../styles/images/checkmark.png';
import times from '../../styles/images/times.png';

const LeaderboardWidget = () => {
    const [leaderboard, setLeaderboard] = useState<Profile[]>();

    useEffect(() => {
        ApiService.get('/leaderboard').then((response) => {
            if (!response) throw new Error("No response");
            if (!response.success) throw new Error(response.message);
            setLeaderboard(response.data);
        });
    }, []);

    const Leaderboard = () => {
        if (leaderboard) {
            if (leaderboard.length === 0)
                return <>No leaderboard results</>;
            if (leaderboard.length > 0) {
                return <>{leaderboard.map((playerStats) => {
                    return (
                        <li className='list-item pt-3 pb-2 px-2 ps-3 mb-2' key={playerStats.address}>
                            <Link to={`/profile/${playerStats.address}`} target="_blank">
                                <Row>
                                    <Col xs={2}>
                                        <img src={getProfilePicture(playerStats?.address)} alt='pfp' height={30} />
                                    </Col>
                                    <Col xs={6}>
                                        <span className='fs-7'>{playerStats.name}</span>
                                    </Col>
                                    <Col xs={2} className='fs-7 text-grey win-lose ps-0 pe-0'>
                                        <img src={checkmark} alt="checkmark" /> {playerStats.wins}<br />
                                        <img src={times} alt="times" /> {playerStats.losses}
                                    </Col>
                                    <Col xs={2} className='text-grey'>
                                        #{leaderboard.indexOf(playerStats) + 1}
                                    </Col>
                                </Row>
                            </Link>
                        </li>
                    )
                })}</>
            }
        }

        return <>Loading stats...</>;
    }

    return (
        <Card className='card-widget' id="leaderboard-widget">
            <Card.Header>
                <Row>
                    <Col>
                        Leaderboard
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body>
                <ul>
                    <Leaderboard />
                </ul>
            </Card.Body>
        </Card>
    );
}

export default LeaderboardWidget;